module.exports = __webpack_public_path__ + "static/media/gallery5.58b8cde0.jpg";